import React, { useContext } from 'react';
import classNames from 'classnames';
import FieldRequiredVisibleInfo from 'components/FieldRequiredVisibleInfo';
import { DealRoomRequiredVisibleInfo } from 'models/DealRoom';
import { FieldRequiredVisibleInfoProps } from 'components/FieldRequiredVisibleInfo/FieldRequiredVisibleInfo.component';
import DealRoomFieldsRequiredVisibleInfoContext from '../../providers/DealRoomFieldsRequiredVisibleInfo/DealRoomFieldsRequiredVisibleInfo.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './DealRoomFieldRequiredVisibleInfo.styles.scss';

type DealRoomFieldRequiredVisibleInfoProps = {
  fieldName: keyof DealRoomRequiredVisibleInfo;
  canChangeRequired?: boolean;
} & Omit<
  FieldRequiredVisibleInfoProps,
  'canChangeRequired' | 'fieldValue' | 'onSubmit'
>;

const DealRoomFieldRequiredVisibleInfo: React.FC<
  DealRoomFieldRequiredVisibleInfoProps
> = (props) => {
  const { className, fieldName, canChangeRequired = true, ...rest } = props;

  const { isSuperAdmin } = useContext(CurrentUserContext);
  const {
    fields,
    canChangeRequired: globalCanChangeRequired,
    updateField,
  } = useContext(DealRoomFieldsRequiredVisibleInfoContext);

  const classes = classNames(
    'deal-room-field-required-visible-info',
    className,
  );

  if (!isSuperAdmin) return null;

  return (
    <FieldRequiredVisibleInfo
      className={classes}
      canChangeRequired={canChangeRequired && globalCanChangeRequired}
      fieldValue={fields?.[fieldName]}
      onSubmit={(values, onSuccess) =>
        updateField(fieldName, values, onSuccess)
      }
      {...rest}
    />
  );
};

export default DealRoomFieldRequiredVisibleInfo;
